import React from 'react';
import { connect } from 'react-redux';
import Notification from './Notification';
import './notifications.scss';

class NotificationBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      top: props.headerHeight + 220
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll = () => {
    const { headerHeight } = this.props;
    const scrollTop = window.pageYOffset || document.body.scrollTop;

    let top = headerHeight - scrollTop;
    top = (top < 0 ? 0 : top) + 20;
    this.setState({ top });
  };

  render() {
    const { notifications, closeNotification } = this.props;
    const { top } = this.state;
    return (
      <div className="position-relative">
        <div
          className="notifications-block"
          style={{ top: `${top}px` }}
        >
          {Object.keys(notifications)
            .map(id => (
              <Notification
                message={notifications[id].message}
                id={id}
                key={id}
                dismiss={closeNotification}
                error={notifications[id].error}
              />
          ))}
        </div>
      </div>
    );
  }
}

export default connect(({ notifications }) => ({
  notifications
}))(NotificationBox);
